import SeoHead from '@/components/feature/SeoHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedNovels from './components/FeaturedNovels';
import CategoryGrid from './components/CategoryGrid';
import HotRanking from './components/HotRanking';
import LatestUpdates from './components/LatestUpdates';
import NewsletterCTA from './components/NewsletterCTA';
import { siteInfo } from '@/mocks/novels';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteInfo.name,
  url: window.location.origin,
  description: siteInfo.description,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${window.location.origin}/search?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SeoHead
        title="都市美艳后宫 - 最强男主的极致宠溺之旅 | 都市爽文推荐"
        description={siteInfo.description}
        keywords={siteInfo.keywords}
        canonicalUrl={window.location.origin}
        ogType="website"
        schema={homeSchema}
      />
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedNovels />
          <CategoryGrid />
          <HotRanking />
          <LatestUpdates />
          <NewsletterCTA />
        </main>
        <Footer />
      </div>
    </>
  );
}